import { DateTime } from 'luxon';
import { getDefaultSearchDate } from '@/utils/helpers';

function formatDateShort(date) {
  return DateTime.fromISO(date).toFormat('yyyy-MM-dd');
}
function formatDateFull(date) {
  return DateTime.fromFormat(date, 'yyyy-MM-dd').toString();
}

export const searchObjectToQueryAdapter = (object) => {
  return {
    departureId: object.departureStation.id,
    arrivalId: object.arrivalStation.id,

    roundTrip: object.roundTrip !== false ? object.roundTrip : undefined,
    departureDate: formatDateShort(object.departureDate),
    returnDate: object.returnDate
      ? formatDateShort(object.returnDate)
      : undefined,

    departureTimeType: object.departureTimeType || undefined,
    departureTime: object.departureTime || undefined,

    returnTimeType: object.returnTimeType || undefined,
    returnTime: object.returnTime || undefined,

    adults: object.adults !== 1 ? object.adults : undefined,
    children: object.children !== 0 ? object.children : undefined,
    infants: object.infants !== 0 ? object.infants : undefined,
    seatsForInfants: object.seatsForInfants || undefined,
  };
};

export const searchQueryToObjectAdapter = (query) => {
  let queryReturnDateDate;
  let queryDepartureDateDate;

  const today = DateTime.local().startOf('day');
  const tomorrow = today.plus({ days: 1 });

  if (query.departureDate) {
    const departureDate = DateTime.fromFormat(
      query.departureDate,
      'yyyy-MM-dd',
    );
    queryDepartureDateDate =
      departureDate < today
        ? today.toString()
        : formatDateFull(query.departureDate);
  } else {
    queryDepartureDateDate = getDefaultSearchDate();
  }

  if (query.returnDate) {
    const returnDate = DateTime.fromFormat(query.returnDate, 'yyyy-MM-dd');
    queryReturnDateDate =
      returnDate < tomorrow
        ? tomorrow.toString()
        : formatDateFull(query.returnDate);
  }

  return {
    departureStation: { id: query.departureId },
    arrivalStation: { id: query.arrivalId },

    roundTrip: query.roundTrip || false,
    departureDate: queryDepartureDateDate,
    returnDate: queryReturnDateDate,

    departureTimeType: query.departureTimeType,
    departureTime: query.departureTime,

    returnTimeType: query.returnTimeType,
    returnTime: query.returnTime,

    adults: query.adults || 1,
    children: query.children || 0,
    infants: query.infants || 0,
    seatsForInfants: query.seatsForInfants,
  };
};
